module.exports = __webpack_public_path__ + "img/icon_sm_rbjssp.8ac3bcad.png";